import { VariantProps } from "class-variance-authority";
import { MessageCircleMore } from "lucide-react";
import { forwardRef } from "react";

import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

import { ActionButton, ActionButtonProps } from "../action-button";

type ToggleChatProps = Omit<ActionButtonProps, "Icon" | "text"> &
  VariantProps<typeof ActionButton> & {
    variant?: "default" | "ghost" | "destructive";
    size?: "fixed" | "auto";
  };

export const ToggleChat = forwardRef<HTMLButtonElement, ToggleChatProps>(
  ({ variant = "default", size = "fixed", ...props }, ref) => {
    const isChatDrawerOpen = useVidyoStore((s) => s.chatDrawer.isOpen);
    const isChatEnabled = useVidyoStore((state) => state.chat.isChatEnabled);
    const openChatDrawer = useVidyoStore((s) => s.chatDrawer.open);
    const closeChatDrawer = useVidyoStore((s) => s.chatDrawer.close);
    const hasUnreadMessages = useVidyoStore((s) => s.chat.hasUnreadMessages);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      if (isChatDrawerOpen) {
        closeChatDrawer();
      } else {
        openChatDrawer();
      }

      // Call the original onClick handler if it exists,
      // this closes the dropdown menu
      props.onClick?.(event);
    };

    return (
      <ActionButton
        {...props}
        ref={ref}
        variant={variant}
        size={size}
        onClick={handleClick}
        Icon={MessageCircleMore}
        text="Chat"
        key="chat"
        isActive={isChatDrawerOpen}
        displayPing={hasUnreadMessages}
        disabled={!isChatEnabled}
      />
    );
  },
);

ToggleChat.displayName = "ToggleChat";
